import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function AboutIronPeakMensHealth() {
  return <section className="pt-8 sm:pt-8 pb-8 bg-background">
      <div className="container">
        {}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-6">
            About IronPeak Men's Health
          </h2>
          <p className="text-lg text-muted-dark max-w-3xl mx-auto leading-relaxed">
            IronPeak Men's Health is a physician-led clinic dedicated to helping men <strong>regain energy, strength, and confidence</strong> through personalized, evidence-based care. Founded in Prosper, Texas, we serve men statewide via secure telemedicine — <strong>guiding them toward sustainable health, performance, and vitality at every stage of adulthood.</strong>
          </p>
        </div>

        {}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <Card className="border border-border shadow-soft bg-primary-light-bg">
            <CardHeader>
              <CardTitle className="text-2xl text-primary font-medium">
                Our Mission
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-foreground leading-relaxed">
                Our mission is to help men regain energy, strength, and confidence — so they can perform at their best in work, training, and life, at every stage of adulthood.
              </p>
            </CardContent>
          </Card>

          <Card className="border border-border shadow-soft bg-secondary-light-bg">
            <CardHeader>
              <CardTitle className="text-2xl text-secondary font-medium">
                Our Values
              </CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-4 text-foreground">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-secondary rounded-full mt-2 mr-3 shrink-0"></span>
                  <div>
                    <strong className="font-semibold">Outcomes Over Interventions</strong>
                    <p className="mt-1 text-sm">We focus on how our patients feel, function, and perform — not just lab numbers or prescriptions.</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-secondary rounded-full mt-2 mr-3 shrink-0"></span>
                  <div>
                    <strong className="font-semibold">Physician-Led, Evidence-Driven Care</strong>
                    <p className="mt-1 text-sm">Every plan is designed and overseen by a licensed physician, grounded in medical evidence and clinical judgment.</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-secondary rounded-full mt-2 mr-3 shrink-0"></span>
                  <div>
                    <strong className="font-semibold">Personalized, Not Protocol-Driven</strong>
                    <p className="mt-1 text-sm">No templates. No one-size-fits-all medicine. Care is tailored to your physiology, goals, and lifestyle.</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-secondary rounded-full mt-2 mr-3 shrink-0"></span>
                  <div>
                    <strong className="font-semibold">Long-Term Strength Over Short-Term Fixes</strong>
                    <p className="mt-1 text-sm">We prioritize sustainable results that support energy, performance, and independence for decades — not quick wins that fade.</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-secondary rounded-full mt-2 mr-3 shrink-0"></span>
                  <div>
                    <strong className="font-semibold">Clarity, Safety, and Accountability</strong>
                    <p className="mt-1 text-sm">We believe in transparent guidance, ongoing monitoring, and responsible medical decision‑making at every step.</p>
                  </div>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>

        {}
        <div className="text-center mb-12">
          <h3 className="text-2xl md:text-3xl font-medium text-foreground mb-4">Meet Your Physician</h3>
          <p className="text-muted-dark max-w-2xl mx-auto">Dr. Flores provides direct, physician-led care — you speak with him, not a sales rep.</p>
        </div>

        <div className="grid md:grid-cols-1 max-w-xl mx-auto gap-8">
          <Card className="border border-border shadow-soft hover-lift">
            <img src="https://relaxed-fowl.10web.cloud/wp-content/uploads/2025/09/Michael-Flores-scaled.jpg" alt="Dr. Michael Flores, D.O." className="w-full h-64 object-cover object-[center_10%] rounded-t-xl" />
            <CardHeader>
              <CardTitle className="text-xl font-medium text-foreground">
                Dr. Michael Flores, D.O.
              </CardTitle>
              <p className="text-primary font-medium">
                Board-Certified Physician | Founder, IronPeak Men's Health
              </p>
            </CardHeader>
            <CardContent>
              <p className="text-muted-dark leading-relaxed">
                I am a board-certified physician with over 10 years of medical experience. As a husband and father of three, I understand the importance of staying strong, healthy, and present for the people who matter most. Guided by strong Christian values, I treat every patient with honesty, compassion, and respect. My mission is simple: to help men reclaim their energy, confidence, and quality of life through safe, evidence-based care.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}